import styled from '@emotion/styled';

const TitleStyled = (Component) => styled(Component)`
  &.ant-typography {
    margin-bottom: 0px;
  }
`;

export default TitleStyled;
